<template>
  <router-link class="header__cart" :to="{ name: 'cart' }" aria-label="Корзина с товарами">
    <svg width="19" height="24">
      <use xlink:href="#icon-cart"></use>
    </svg>
    <div class="header__count" v-if="$store.state.cartLoading">
      <img src="../../public/img/Spinner-white.svg" width="8" height="8">
    </div>
    <span class="header__count" aria-label="Количество товаров" v-else-if="!$store.state.cartLoading">{{
      $store.state.cartProducts.length }}</span>
  </router-link>
</template>
<script>
export default {
}
</script>

